'use client'
import { getActiveSalonId } from 'Containers/Auth/store/selectors';
import React from 'react';
import { useSelector } from 'react-redux';

const AppPrivataIcon = ({ size = 18, alt = '' }) => {
  const activeSalonId = useSelector(getActiveSalonId());
  const src = `https://backoffice-barbieri.zetabarber.it/img/salone?id=${activeSalonId}&tipo=profilo`;

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '20px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </div>
  );
};

export default AppPrivataIcon;

